import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function ShipmentsPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ color: 'var(--grey-900)', mb: 1 }}>
        Shipments
      </Typography>
      <Typography sx={{ color: 'var(--grey-500)', fontSize: '0.875rem' }}>
        Coming Soon
      </Typography>
      <Box component="ul" sx={{ mt: 1, pl: 3 }}>
        {[
          'Dispatch Board: outbound shipments from FSL and warehouse fulfillments',
          'Replenishment: supplier-to-customer shipments for part replenishment orders',
        ].map((item) => (
          <Box component="li" key={item}>
            <Typography sx={{ color: 'var(--grey-500)', fontSize: '0.875rem' }}>
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
